import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import "./DoraWeekdays.scss";
const weekdays = [1, 2, 3, 4, 5, 6, 7];
const DoraWeekdays = (props) => {
    const { t } = useTranslation("schedules");
    const { hasError, activeWeekdays, onWeekdayClick } = props;
    const classes = clsx("dora-weekdays", { "dora-weekdays--error": hasError });
    return (_jsx("div", { className: classes, children: weekdays.map((weekday) => (_jsx("button", { className: clsx("schedule-weekdays__day", {
                active: activeWeekdays.includes(weekday),
            }), type: "button", onClick: () => onWeekdayClick(weekday), children: t(`weekdaysNames.${weekday}`) }, weekday))) }));
};
export default DoraWeekdays;
//# sourceMappingURL=DoraWeekdays.js.map